import { AbiItem } from 'web3-utils'
import UniversalProfile from '@lukso/lsp-smart-contracts/artifacts/UniversalProfile.json'

export const universalProfileABI: AbiItem[] = UniversalProfile.abi as AbiItem[]
